import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
declare let gtag: Function;
@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  windowObjectRef: any;
  isBrowser: any;
  isClientAssistEnabled: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.windowObjectRef = ((window as any));
    }
    // this.isClientAssistEnabled;
  }

  public eventEmitter(
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
    eventValue: number,
    eventName?: string,
    ){
    gtag('event', eventName, {
      eventCategory,
      eventLabel,
      eventAction,
      eventValue
    });
  }

  public pushDirectEvent(category, action, label) {
    // if (this.isBrowser && !this.isClientAssistEnabled) {
    //   setTimeout(() => {
    //     // this.windowObjectRef.ga('send', {
    //     //   hitType: 'event',
    //     //   eventCategory: category,
    //     //   eventAction: action,
    //     //   eventLabel: label
    //     // });
    //     ga('send', {
    //       hitType: 'event',
    //       eventCategory: category,
    //       eventAction: action,
    //       eventLabel: label
    //     });
    //   }, 10);
    // }
  }

  public pushDataLayerEvent(eventName) {
    if (this.isBrowser && !this.isClientAssistEnabled) {
      setTimeout(() => {
        this.windowObjectRef.dataLayer.push({
          event: eventName
        });
      }, 10);
    }
  }

  public pageViewEvent(pageName, eventName) {
    if (this.isBrowser && !this.isClientAssistEnabled) {
      setTimeout(() => {
        this.windowObjectRef.dataLayer.push({
          currentPage: pageName,
          event: eventName
        });
      });
    }
  }

  public pushDataLayerVariable(variableName, variableValue) {
    if (this.isBrowser && !this.isClientAssistEnabled) {
      setTimeout(() => {
        this.windowObjectRef.dataLayer.push({
          [variableName]: variableValue
        });
      }, 10);
    }
  }



  // public eventEmitter(
  //   eventName: string,
  //   eventCategory: string,
  //   eventAction: string,
  //   eventLabel: string,
  //   eventValue: number ){
  //     gtag('event', eventName, {
  //       eventCategory,
  //       eventLabel,
  //       eventAction,
  //       eventValue,
  //       send_to: 'UA-175892077-1'
  //     });
  //   }
}
